import React from "react";
import EastIcon from "@mui/icons-material/East";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import AbsoluteSkewebar from "@/components/Common/AbsoluteSkewebar";
import { getCDNImageUrl } from "@/utils/Common";
const hiringDatas = [
  {
    id: 3,
    image: getCDNImageUrl("assignment.svg"),
    name: "Total Product Ownership",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },
  {
    id: 2,
    image: getCDNImageUrl("call.svg"),
    name: "Tech-Enabled Supply Chain",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },
  {
    id: 1,
    image: getCDNImageUrl("document-filled.svg"),
    name: "Customer-Centric Innovation",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },
  {
    id: 5,
    image: getCDNImageUrl("office-building.svg"),
    name: "Trust, Transparency & Reliability",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },

  {
    id: 4,
    image: getCDNImageUrl("office-building.svg"),
    name: "Sourcing & Manufacturing",
    icon: <EastIcon />,
    icon2: <ArrowDownwardIcon />,
  },
];

const HiringCard = () => {
  return (
    <div className="mt-16 md:mt-5">
      <div className="flex text-3xl ">
        <AbsoluteSkewebar text={"Why Elchemy"} />
      </div>
      <div className="flex flex-wrap mt-2 md:mt-10  md:w-full md:flex-row p-4 justify-center md:items-center gap-2 md:gap-16">
        {hiringDatas.map((hiringData, index) => (
          <>
            <div
              className="flex flex-col items-center justify-between mb-5 md:mb-0 md:mr-5"
              key={hiringData?.id}
            >
              <div className="w-[90px] h-[90px]  md:w-[100px] md:h-[100px] font-mukta rounded-[100%] bg-[#EF41361A] flex justify-center items-center">
                <img
                  src={hiringData?.image}
                  alt={hiringData?.name}
                  className="h-[49px]"
                />
              </div>
              <h5 className="text-[#161616] font-normal text-[20px] w-[8rem] md:w-[10rem] md:text-[15px] font-mukta capitalize mt-3 text-center break-normal">
                {hiringData?.name}
              </h5>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default HiringCard;
